module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('transition', {
    attrs: {
      "name": "slide-fade"
    }
  }, [(!_vm.showCustomLogin) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "jumbotron"
  }, [_c('h2', [_vm._v("Sou Servidor do IFPE")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("Para todos os servidores do IFPE com acesso unificado")]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "btn btn-success btn-lg",
    attrs: {
      "role": "button"
    },
    on: {
      "click": _vm.askAuthIFPE
    }
  }, [_vm._v("Entrar com minha conta")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "jumbotron"
  }, [_c('h2', [_vm._v("Demais Usuários")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("Para todos os estudantes e usuários externos")]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        _vm.showCustomLogin = true
      }
    }
  }, [_vm._v("Entrar/Cadastrar")])])])])]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-fade"
    }
  }, [(_vm.showCustomLogin) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-signin"
  }, [_c('h2', {
    staticClass: "form-signin-heading"
  }, [_vm._v("Acesso ao Sistema")]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.errorMessage) ? _c('div', {
    staticClass: "alert alert-warning"
  }, [_vm._v(_vm._s(_vm.errorMessage))]) : _vm._e()]), _vm._v(" "), _c('label', {
    staticClass: "sr-only",
    attrs: {
      "for": "inputLogin"
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.login),
      expression: "login"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "id": "inputLogin",
      "placeholder": "Email",
      "required": "",
      "autofocus": ""
    },
    domProps: {
      "value": (_vm.login)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.doLogin.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.login = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "sr-only",
    attrs: {
      "for": "inputPassword"
    }
  }, [_vm._v("Senha")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "id": "inputPassword",
      "placeholder": "Senha",
      "required": ""
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.doLogin.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('button', {
    staticClass: "btn btn-lg btn-block btn-primary col-sm-6",
    attrs: {
      "id": "bntLogin"
    },
    on: {
      "click": _vm.doLogin
    }
  }, [_vm._v("Entrar")])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.loading) ? _c('div', [_c('loader')], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "extraActions"
  }, [_c('p', [_c('router-link', {
    attrs: {
      "to": "/signup"
    }
  }, [_vm._v("Não possui conta? Cadastre-se")])], 1), _vm._v(" "), _c('p', [_c('router-link', {
    attrs: {
      "to": "/password-reset"
    }
  }, [_vm._v("Esqueci a senha")])], 1), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "javascript:void()"
    },
    on: {
      "click": function($event) {
        _vm.showCustomLogin = false
      }
    }
  }, [_vm._v("Voltar")])])])], 1)]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2c9be824"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login.vue
// module id = 1441
// module chunks = 1